import { DOCUMENTATION_MODULES, GETTING_STARTED } from './documentationContent';
import { MODULE_SETUP_GUIDES } from './moduleSetupGuides';

export const DOC_VIEWS = {
  OVERVIEW: 'overview',
  GETTING_STARTED: 'getting-started',
  MODULE: 'module',
  GUIDE: 'guide',
};

export function parseDocumentationPath(pathname) {
  const base = pathname.replace(/\/+$/, '');
  const rest = base.replace(/^\/documentation\/?/, '');
  const parts = rest ? rest.split('/').filter(Boolean) : [];

  if (parts.length === 0 || parts[0] === 'overview') {
    return { view: DOC_VIEWS.OVERVIEW };
  }

  if (parts[0] === 'getting-started') {
    if (!parts[1]) {
      return { view: DOC_VIEWS.GETTING_STARTED };
    }
    const guide = GETTING_STARTED.guides.find((g) => g.id === parts[1]);
    if (guide) {
      return { view: DOC_VIEWS.GUIDE, section: 'getting-started', guideId: parts[1], guide };
    }
    return { view: DOC_VIEWS.GETTING_STARTED };
  }

  const mod = DOCUMENTATION_MODULES.find((m) => m.id === parts[0]);
  if (!mod) {
    return { view: DOC_VIEWS.OVERVIEW };
  }

  if (!parts[1] || parts[1] === 'setup-overview') {
    return { view: DOC_VIEWS.MODULE, moduleId: mod.id, module: mod };
  }

  const setup = MODULE_SETUP_GUIDES[mod.id]?.guides?.find((g) => g.id === parts[1]);
  if (setup) {
    return {
      view: DOC_VIEWS.GUIDE,
      section: mod.id,
      moduleId: mod.id,
      module: mod,
      guideId: parts[1],
      guide: setup,
    };
  }

  return { view: DOC_VIEWS.MODULE, moduleId: mod.id, module: mod };
}

export function docPathOverview() {
  return '/documentation/overview';
}

export function docPathGettingStarted() {
  return '/documentation/getting-started';
}

export function docPathGettingStartedGuide(guideId) {
  return `/documentation/getting-started/${guideId}`;
}

export function docPathModule(moduleId) {
  return `/documentation/${moduleId}/setup-overview`;
}

export function docPathModuleGuide(moduleId, guideId) {
  return `/documentation/${moduleId}/${guideId}`;
}
